<template>
	<b-col>
		<b-row>
         <b-col><h3 class="ml-3">ASIN tauschen</h3></b-col>
		</b-row>
		<b-row class="my-2">
			<b-col>
				<b-form-input v-model="materialIdFirst" placeholder="Material ID"></b-form-input>
			</b-col>
			<b-col>
				<b-form-input v-model="materialIdSecond" placeholder="Material ID"></b-form-input>
			</b-col>
			<b-col class="col-1 ml-0 pl-0">
				<b-col />
				<b-col class="p-0">
					<b-button block size="md" @click="submit()" variant="primary" :busy="busy">
						<span class="icon icon-loop" />
					</b-button>
				</b-col>
				<b-col />
			</b-col>
		</b-row>
		<b-row class="my-2 py-2">
			<b-table v-if="jobs" :items="jobs" :fields="fields" :tbody-tr-class="rowClass" small>
				<template v-slot:cell(materialIdFirst)="data">
					<b-button
						size="sm"
						block
						variant="outline-secondary"
						@click="openInNewTab(`material/${data.item.materialIdFirst}/edit`)"
						class="float-right"
					>
						<b style="font-family:'Lucida Console', monospace">{{data.item.materialIdFirst}}</b>
					</b-button>
				</template>

				<template v-slot:cell(materialIdSecond)="data">
					<b-button
						size="sm"
						block
						variant="outline-secondary"
						@click="openInNewTab(`material/${data.item.materialIdSecond}/edit`)"
						class="float-right"
					>
						<b style="font-family:'Lucida Console', monospace">{{data.item.materialIdSecond}}</b>
					</b-button>
				</template>

				<template v-slot:cell(actions)="data">
               <b v-if="(!data.item.finished_at) && jobSchedule.lastUpdateReason === 'finished job execution with error'">C-Job Fehler</b>
					<span v-else-if="!data.item.finished_at" class="float-right">
						<b-spinner small />
					</span>
				</template>
			</b-table>
		</b-row>
		<b-modal v-model="modalError.state" size="md" centered dismissible>{{modalError.message}}</b-modal>
	</b-col>
</template>
<script>
export default {
   data() {
      return {
         users: [],
         materialIdFirst: null,
         materialIdSecond: null,
         modalError: {
            state: false,
            message: ""
         },
         fields: [
            { key: "materialIdFirst", label: "Material ID" },
            { key: "materialIdSecond", label: "Material ID" },
            {
               key: "created_at",
               label: "erstellt am",
               formatter: function(s) { return s ? moment(s).format("DD.MM.YYYY HH:mm") : "‒" }
            },
            {
               key: "finished_at",
               label: "abgeschlossen am",
               formatter: function(s) { return s ? moment(s).format("DD.MM.YYYY HH:mm") : "‒" }
            },
            {
               key: "userId",
               label: "Benutzer",
               formatter: userId => {
                  if((!this.users) || (this.users.length == 0)) return "";
                  let maybe = this.users.find(user => user.id == userId);
                  return (maybe) ? maybe.name : "unbekannt";
               }
            },
				/*{ 
                    key: 'state',
                    label: 'Zustand', 
                    formatter: function(s) {
                        switch(s) {
                            case 'created':  return 'erstellt';
                            case 'error':    return 'Fehler';
                            case 'finished': return 'abgeschlossen';
                        }
                        return 'unbekannt';
                    }
                },*/
            { key: "actions", label: "Jobzustand" }
         ],
         jobs: null,
         jobSchedule: null,
         busy: false
      };
   },
   methods: {
      rowClass(item, type) {
         //
         if(item.finished_at) return "";
         if(this.jobSchedule.lastUpdateReason === 'finished job execution with error') return 'table-danger'; // if job isn't
         if(Math.abs(moment(item.created_at).diff(moment(), 'minutes')) > 180) return 'table-warning'; // if job isn't done within 3 hours, something is going wrong
         console.log("called rowClass");
           
      },
      submit() {
         this.busy = true;
         let payload = {
            materialIdFirst: this.materialIdFirst,
            materialIdSecond: this.materialIdSecond
         };
         axios.post( "/materialasinswapjob", payload)
         .then( (response) => {
            console.log(response.data);
            if(response.data === 'Unfinished job already exists') {
               this.modalError = {
                  state: true,
                  message: `Ein offener Job mit diesem MaterialID-Paar (${payload.materialIdFirst}, ${payload.materialIdSecond}) existiert bereits. Joberstellung wurde abgebrochen.`
               };
            }else{
               this.reload();
            }
         }).catch( error => {
            this.modalError = {
               state: true,
               message: "Netzwerkfehler. Error: " + JSON.stringify(error)
            };
            this.busy = false;
         });
      },
      openInNewTab(url) {
         var win = window.open(url, "_blank");
         win.focus();
      },
      reload() {
         this.materialIdFirst = "";
         this.materialIdSecond = "";
         this.busy = true;
         Promise.all([
            axios.get( "/materialasinswapjob/getamount/100"  ),
            (this.jobSchedule) ? Promise.resolve() : axios.get('/jobschedule/byclassname/C2_AsinSwapJob')
         ])
         .then( ([response, responseJobSchedule]) => { 
            this.jobs = response.data;
            if(!this.jobSchedule) this.jobSchedule = responseJobSchedule.data;
            //this.nextRunTime = moment(this.jobSchedule.nextRun).diff(moment(), 'minutes');
            this.busy = false;
         });
      }
   },
   created() {
      this.reload();
      axios.get( "/user/get" ).then( response => (this.users = response.data));
    
   }
};
</script>
